import type { R2BAvailableBrandEntity } from "../../entity_types/r2bAvailableBrand";

export const defaultR2BAvailableBrand: R2BAvailableBrandEntity = {
  token: "default",
  type: "r2bAvailableBrand",
  benefits: [],
  name: "Default Available Brand",
  stagingBrandToken: "default",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
